import { Loader2 } from 'lucide-react'

/**
 * Google でのログイン中、画面全体を覆って「ログイン中」を出す。
 *
 * GIS のボタンは Google が描画するため、自前のボタンのように disabled や
 * 文言の切り替えができない (`aria-busy` を付けても見た目は変わらない)。
 * そのため Google のアカウント選択から戻った後、サーバの応答を待つ数秒間
 * (本番は API が 0 台から起動することもある) **ログイン画面がそのまま
 * 押せる状態で見えていた**。利用者は「戻された」と受け取って押し直し、
 * 「2 回ログインしないと入れない」と報告されていた。
 *
 * 覆っている間は下の画面を押せない (ゲストボタン等の誤操作も防ぐ)。
 * 処理中に別のモーダル (Passkey / TOTP) を出す画面では、呼び元がその間
 * `show` を false にすること — 覆うとモーダルを操作できなくなる。
 */
export default function SigningInOverlay({ show, message }: { show: boolean; message: string }) {
  if (!show) return null
  return (
    <div
      className="fixed inset-0 z-[90] flex flex-col items-center justify-center gap-3 bg-warm-white/85 backdrop-blur-sm animate-fade-in"
      role="status"
      aria-live="polite"
    >
      <Loader2 size={32} className="animate-spin text-navy" />
      <p className="font-body text-[15px] font-medium text-text-primary">{message}</p>
    </div>
  )
}
